import React, { createContext, useContext, useMemo } from 'react'
import MobileSDKMessaging from './MobileSDKMessaging'

type MobileSDKContextType = {
  isMobileSDKContext: boolean
  messagingSDK: MobileSDKMessaging | null
};

type MobileSDKProviderProps = React.PropsWithChildren<{
  componentName: string
  componentVersion?: string
}>;

const MobileSDKContext = createContext<MobileSDKContextType>({
  isMobileSDKContext: false,
  messagingSDK: null,
})

export const MobileSDKProvider: React.FC<MobileSDKProviderProps> = ({
  children,
  componentName,
  componentVersion = '1.0.0',
}) => {
  const isMobileSDKContext = MobileSDKMessaging.isMobileSDKContext()
  const messagingSDK = useMemo(
    () => (isMobileSDKContext
      ? new MobileSDKMessaging({
        componentName,
        componentVersion,
      })
      : null),
    [isMobileSDKContext, componentName, componentVersion]
  )

  React.useEffect(() => {
    if (isMobileSDKContext && messagingSDK) {
      messagingSDK.handshake().catch(() => {
        // silent error (fallback mechanism)
      })
    }
  }, [isMobileSDKContext, messagingSDK])

  return (
    <MobileSDKContext.Provider value={{ isMobileSDKContext, messagingSDK }}>
      {children}
    </MobileSDKContext.Provider>
  )
}

export const useMobileSDKContext = () => useContext(MobileSDKContext)
